import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../lib/http/axiosConfig";
import "./Auth.css";
import { getDeviceId } from "../../lib/deviceId";

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirmPassword: "",
    email: "",
    phone: "",
    nickname: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 로그인 상태 체크
  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      // 이미 로그인된 상태라면 메인 페이지로 리다이렉트
      navigate("/", { replace: true });
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validateForm = () => {
    if (formData.password !== formData.confirmPassword) {
      setError("비밀번호가 일치하지 않습니다.");
      return false;
    }

    if (formData.password.length < 6) {
      setError("비밀번호는 최소 6자 이상이어야 합니다.");
      return false;
    }

    if (formData.username.length < 3) {
      setError("아이디는 최소 3자 이상이어야 합니다.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    try {
      const registerData = {
        username: formData.username,
        password: formData.password,
        email: formData.email,
        phone: formData.phone,
        nickname: formData.nickname,
        deviceId: getDeviceId(),
      };

      const { data } = await axios.post("/api/auth/register", registerData);

      if (!data.success) throw new Error(data.error.message);

      if (data.data) {
        // 토큰을 localStorage에
        const payload = data.data;
        localStorage.setItem("accessToken", payload.accessToken);
        localStorage.setItem(
          "accessTokenExpAt",
          String(Date.now() + (payload.accessTokenExpiresInSec ?? 0) * 1000)
        ); // 기존 코드 유지
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("refreshTokenExpAt");
        localStorage.setItem("role", payload.role);

        console.log("로그인 성공");
        // 메인 페이지로 리다이렉트
        navigate("/");
      }
    } catch (err) {
      setError(err?.response?.data?.error?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>회원가입</h2>
          {/* 회원가입 비활성화 메시지 - 필요시 주석 해제*/}
          {/* <p style={{ color: "#dc3545", fontWeight: "bold" }}>
            ⚠️ 일시적으로 회원가입이 비활성화되었습니다
          </p> */}
        </div>

        {/* 회원가입 폼 - 활성화됨 */}
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="아이디 (3자 이상)"
              minLength="3"
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="비밀번호 (6자 이상)"
              minLength="6"
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              placeholder="비밀번호 확인"
            />
          </div>

          <div className="form-group">
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="이메일"
            />
          </div>

          <div className="form-group">
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="연락처"
            />
          </div>

          <div className="form-group">
            <input
              type="text"
              id="nickname"
              name="nickname"
              value={formData.nickname}
              onChange={handleChange}
              required
              placeholder="닉네임 (2자 이상)"
              minLength="2"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? "가입 중..." : "회원가입"}
          </button>
        </form>

        {/* 회원가입 비활성화 UI - 필요시 주석 해제*/}
        {/* <div
          style={{
            textAlign: "center",
            padding: "40px 20px",
            color: "#6c757d",
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "20px" }}>🚧</div>
          <h3 style={{ marginBottom: "15px", color: "#495057" }}>
            회원가입 일시 중단
          </h3>
          <p style={{ lineHeight: "1.6", marginBottom: "30px" }}>
            현재 회원가입이 일시적으로 중단되었습니다.
            <br />
            빠른 시일 내에 서비스를 재개할 예정입니다.
          </p>
          <div
            style={{
              background: "#f8f9fa",
              padding: "15px",
              borderRadius: "8px",
              border: "1px solid #e9ecef",
              marginBottom: "30px",
            }}
          ></div>
        </div> */}

        <div className="auth-footer">
          <p>
            이미 계정이 있으신가요?{" "}
            <span className="link-button" onClick={() => navigate("/login")}>
              로그인
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
